import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import useUiuxStore from "src/store/useUiuxStore";
import { TopbarMenu } from "./TopbarMenu";
import useMenuStore from "src/store/useMenuStore";
import useUserStore from "src/store/useUserStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetAllStores } from "src/utils/store/resetAllStores";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { BookmarkTopbarMenu } from "./BookmarkTopbarMenu";
import { PasswordChangeModal } from "../modal/PasswordChangeModal";
import { PrinterSettingModal } from "../modal/printerSettingModal/PrinterSettingModal";
import { logout } from "src/apis/authApi";
import { clearStoredTokens, clearLoginRecorded } from "src/utils/auth/authConfig";

const Topbar = () => {

	const navigate = useNavigate();

	const { sidebarVisible, setSidebarVisible, resetTabList, isPrinterSettingModalOpen, setIsPrinterSettingModalOpen } = useUiuxStore()
	const { menuList, setOpenedMenuMap, setOpenedSecondMenuMap } = useMenuStore();
	const { company, userInfo } = useUserStore();
	const { bookMarkCd } = useCommonCodeStore();
	const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
	
	// 1차 메뉴만 필터링 (useYn='Y'인 메뉴만)
	const filteredMenuList = menuList.filter(menu => 
		menu.menuLevel === 1 && menu.useYn === 'Y' && menu.menuCd !== bookMarkCd
	); 

	const handleLogoutClick = async () => {
		try {
			await logout();
		} catch (e) {
			console.warn('로그아웃 API 실패 (무시)', e);
		}

		// 사이드바 상태 초기화
		menuList.forEach(menu => {
			setOpenedMenuMap(menu.menuCd, false);
			menu.subMenu.forEach(secondMenu => {
				setOpenedSecondMenuMap(secondMenu.menuCd, false);
			});
		});
		
		// 탭 상태 초기화
		resetTabList();
		
		// 모든 스토어 초기화
		resetAllStores();
		
		clearStoredTokens();
		clearLoginRecorded();
		navigate('/signin');
	}

	return <div className="w-full h-[40px] flex items-center justify-between px-[12px] gap-[6px] bg-blue-dark">
		<div className="flex w-[80%] min-w-[80%] h-full">
			<div className="flex w-[150px] min-w-[150px] truncate gap-[4px]">
				{company && <img className="h-full object-contain" src={`data:image/png;base64,${company.logoImage}`} />}
				<p className="flex items-center text-white">
					{/*{company?.compNmFull}*/}
				</p>
			</div>
			{sidebarVisible && <MenuFoldOutlined className='text-white text-[20px] mr-[20px]' onClick={() => setSidebarVisible(!sidebarVisible)} />}
			{!sidebarVisible && <MenuUnfoldOutlined className="text-white text-[20px] mr-[20px]" onClick={() => setSidebarVisible(!sidebarVisible)} />}
				<div className="flex flex-1 h-full gap-[40px] justify-end">
					<div className="flex flex-1 h-full">
						<BookmarkTopbarMenu key={bookMarkCd} />
						{filteredMenuList.map((menu) => 
							<>
								<TopbarMenu data={menu} key={menu.menuCd} />
							</>
						)}
					</div>
				</div>
			{/* } */}
		</div>
		<div className="min-w-[20%] flex justify-end items-center text-white gap-[16px]">
			<p
				className="flex items-center gap-[8px] truncate cursor-pointer group"
				onClick={() => setIsPasswordModalOpen(true)}
				title="비밀번호 변경"
			>
				<img
					src={`${process.env.PUBLIC_URL || ""}/images/icon/user.png`}
					alt=""
					aria-hidden="true"
					className="h-[24px] w-[24px] object-contain shrink-0 rounded-full"
				/>
				<span className="truncate text-white group-hover:text-blue-200 transition-colors">
					{userInfo?.userNm}님
				</span>
			</p>
			<button
				type="button"
				className="flex items-center justify-center  cursor-pointer hover:opacity-80 transition-opacity"
				onClick={() => setIsPrinterSettingModalOpen(true)}
				title="프린터 설정"
			>
				<img
					src={`${process.env.PUBLIC_URL || ''}/print/Scan.png`}
					alt="프린터 설정"
					className="h-8 w-auto object-contain"
				/>
			</button>
			
			<button className="bg-red-500 px-3 py-1 rounded truncate" onClick={handleLogoutClick}>
				로그아웃
			</button>
			
		</div>
		<PasswordChangeModal 
			isOpen={isPasswordModalOpen} 
			onClose={() => setIsPasswordModalOpen(false)} 
		/>
		<PrinterSettingModal
			isOpen={isPrinterSettingModalOpen}
			onClose={() => setIsPrinterSettingModalOpen(false)}
		/>
	</div>
}

export default Topbar;